module.exports = {"id":"202271","name":"Akaki Gogia","rating":"71","photo":"./data/images/photos/3/202271.png","club":{"name":"Union Berlin","logo":"./data/images/clubs/UnionBerlin.png"},"positions":["AD","MD"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AkakiGogia0.json
// module id = 143
// module chunks = 0